import {
  ANALYST_VALUE,
  AUDITOR_VALUE,
  COMPANY_USER_VALUE,
  DOCUMENT_VIEWER_VALUE,
  EXPORT_VIEWER_VALUE,
  FIRM_ADMIN_VALUE,
  FULL_ACCESS_VIEWER_VALUE,
  FUND_ADMIN_VALUE,
  LIMITED_VIEWER_VALUE,
} from 'common/constants/user';

export interface RolePermissions {
  canUseInfoRequestLedger: boolean;
  canViewDocuments: boolean;
  canDownloadDocuments: boolean;
  canEditSetup: boolean;
  canSendInfoRequest: boolean;
  canCopyPortalLink: boolean;
}

export const getRolePermissions = (userRole: number): RolePermissions => {
  // Default permissions - most restrictive
  const basePermissions: RolePermissions = {
    canUseInfoRequestLedger: false,
    canViewDocuments: false,
    canDownloadDocuments: false,
    canEditSetup: false,
    canSendInfoRequest: false,
    canCopyPortalLink: false,
  };

  switch (userRole) {
    case FIRM_ADMIN_VALUE:
    case FUND_ADMIN_VALUE:
    case ANALYST_VALUE:
      return {
        ...basePermissions,
        canUseInfoRequestLedger: true,
        canViewDocuments: true,
        canDownloadDocuments: true,
        canEditSetup: true,
        canSendInfoRequest: true,
        canCopyPortalLink: true,
      };

    case AUDITOR_VALUE:
    case FULL_ACCESS_VIEWER_VALUE:
    case EXPORT_VIEWER_VALUE:
    case DOCUMENT_VIEWER_VALUE:
      return {
        ...basePermissions,
        canViewDocuments: true,
        canDownloadDocuments: true,
      };

    case COMPANY_USER_VALUE:
    case LIMITED_VIEWER_VALUE:
      return {
        ...basePermissions,
        canViewDocuments: true,
        canDownloadDocuments: false,
      };

    default:
      return basePermissions;
  }
};
